import type { ICity } from "country-state-city/lib/interface";
import type { JSX } from "react";
import { useEffect, useState } from "react";
import type { GenericSelectItem } from "@/common/types/types";
import { Combobox } from "@/components/ui/Combobox";

interface Props {
  placeholder?: string;
  onValueChange: ({ value, label }: { value: string; label: string }) => void;
  value?: string;
  countryCode: string;
  stateCode: string;
}

export const CityCombobox = (props: Props): JSX.Element => {
  const [cities, setCities] = useState<GenericSelectItem[]>([]);

  const getCities = async (
    countryCode: string,
    stateCode: string,
  ): Promise<GenericSelectItem[]> => {
    const City = await import("country-state-city/lib/city");
    const { getCitiesOfState } = City.default;
    return getCitiesOfState(countryCode, stateCode).map((city: ICity) => ({
      label: city.name,
      value: city.name,
    }));
  };

  useEffect(() => {
    void getCities(props.countryCode, props.stateCode).then(setCities);
  }, [props.countryCode, props.stateCode]);

  return (
    <Combobox
      items={cities}
      placeholder={props.placeholder}
      value={props.value}
      onValueChange={(value) => {
        props.onValueChange({ label: value.label, value: value.value });
      }}
    />
  );
};
